'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateNorwegianIdNumber = validateNorwegianIdNumber;
exports.possibleAgesOfPersonWithIdNumber = possibleAgesOfPersonWithIdNumber;
exports.idNumberContainsBirthDate = idNumberContainsBirthDate;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateNorwegianIdNumber(idNumber) {
  var trimmed = idNumber.trim();
  if (isNaN(trimmed)) return false;
  if (trimmed.length !== 11) return false;
  if (!isValidCheckDigits(trimmed)) return false;
  var type = idNumberType(trimmed);
  if (type === 'FHNumber') return true;else return possibleAgesOfPersonWithIdNumber(trimmed).length > 0;
}

function possibleAgesOfPersonWithIdNumber(elevenDigits) {
  return possibleBirthDatesOfIdNumber(elevenDigits).map(function (birthDate) {
    return (0, _moment2.default)().diff(birthDate, 'years');
  }).filter(function (age) {
    return age >= 0 && age < 125;
  });
}

function idNumberContainsBirthDate(elevenDigits) {
  return idNumberType(elevenDigits) !== 'FHNumber';
}

function possibleBirthDatesOfIdNumber(elevenDigits) {
  if (elevenDigits.length !== 11) return [];
  var type = idNumberType(elevenDigits);
  switch (type) {
    case 'birthNumber':
      return possibleBirthDateOfBirthNumber(elevenDigits);
    case 'DNumber':
      return possibleBirthDateOfDNumber(elevenDigits);
    case 'HNumber':
      return possibleBirthDateOfHNumber(elevenDigits);
  }
  return [];
}

function idNumberType(elevenDigits) {
  var firstDigit = parseInt(elevenDigits[0]);
  if (firstDigit === 8 || firstDigit === 9) return 'FHNumber';
  if (firstDigit >= 4 && firstDigit <= 7) return 'DNumber';
  var thirdDigit = parseInt(elevenDigits[2]);
  if (thirdDigit === 4 || thirdDigit === 5) return 'HNumber';else return 'birthNumber';
}

function possibleBirthDateOfBirthNumber(elevenDigits) {
  return date(elevenDigits);
}

function possibleBirthDateOfHNumber(elevenDigits) {
  var correctedThirdDigit = (parseInt(elevenDigits[2]) - 4).toString();
  return date(elevenDigits.slice(0, 2) + correctedThirdDigit + elevenDigits.slice(3, 11));
}

function possibleBirthDateOfDNumber(elevenDigits) {
  var correctedFirstDigit = (parseInt(elevenDigits[0]) - 4).toString();
  return date(correctedFirstDigit + elevenDigits.slice(1, 11));
}

function date(elevenDigitsWithDDMMYY) {
  var DDMM = elevenDigitsWithDDMMYY.slice(0, 4);
  var YY = elevenDigitsWithDDMMYY.slice(4, 6);
  var ageGroupNumber = parseInt(elevenDigitsWithDDMMYY.slice(6, 9));
  var centuryPrefixes = ['19'];
  if (ageGroupNumber >= 500 && ageGroupNumber < 1000) {
    centuryPrefixes = ['20'];
  }
  if (ageGroupNumber >= 500 && ageGroupNumber < 750) {
    centuryPrefixes = ['20', '18'];
  }
  if (ageGroupNumber >= 900 && ageGroupNumber < 1000) {
    centuryPrefixes = ['19', '20'];
  }
  var possibleDates = centuryPrefixes.map(function (century) {
    return (0, _moment2.default)(DDMM + century + YY, 'DDMMYYYY', true);
  }).filter(function (date) {
    return date.isValid();
  });
  return possibleDates;
}

function isValidCheckDigits(elevenDigits) {
  var staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
  var staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];

  var elevenDigitsArray = elevenDigits.split('').map(Number);

  return isValidCheckDigit(staticSequenceFirstCheckDigit, elevenDigitsArray) && isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray);
}

function isValidCheckDigit(staticSequence, elevenDigits) {
  var productSum = staticSequence.reduce(function (acc, value, index) {
    return acc + value * elevenDigits[index];
  }, 0);

  return productSum % 11 === 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/norwegian-national-id-validator/lib/index.js
// module id = 216
// module chunks = 0